import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
// 搜索列表页
export var searchM = function searchM(keyword) {
  return "//m.zhuanzhuan.com/open/ZZOpenBusiness/index.html?common=true&needHideHead=1&keyword=".concat(keyword, "&webview=zzn#/game-search");
}; // 授权接口地址

export var jsticket = function jsticket(wxPublicId, callbackName) {
  return "https://app.zhuanzhuan.com/zzopen/wxcommon/getJsTicket?wxPublicId=".concat(wxPublicId, "&url=") + encodeURIComponent(window.location.href.split("#")[0]) + '&callback=' + callbackName;
};